<div class="register form-frame wide">
  <app-logo></app-logo>

  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="form-frame__body">

    <app-progress
      [percent]="'20'">
    </app-progress>

    <div class="form-frame__body-head">
      <h2 class="headline">{{'PERSONAL_DATA_PAGE.TITLE' | translate}}</h2>
    </div>

    <p
      class="form-frame__body-description">
      {{'PERSONAL_DATA_PAGE.DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">
      <div class="line">
        <div
          [class.error]="form.get('surnameFormControl')?.invalid && form.get('surnameFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="surnameFormControl"
            id="surname"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="surname"
            class="placeholder">
            {{'PERSONAL_DATA_PAGE.SURNAME' | translate}}
          </label>
          <ng-container *ngIf="form.get('surnameFormControl')?.invalid && form.get('surnameFormControl')?.touched">
            <span
              *ngIf="surnameRequiredError"
              class="input-block__error">
              {{'PERSONAL_DATA_PAGE.SURNAME_REQUIRED' | translate}}
            </span>
            <span
              *ngIf="surnameFormatError"
              class="input-block__error">
              {{'PERSONAL_DATA_PAGE.SURNAME_INVALID' | translate}}
            </span>
          </ng-container>
        </div>

        <div
          [class.error]="form.get('firstnameFormControl')?.invalid && form.get('firstnameFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="firstnameFormControl"
            id="firstname"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="firstname"
            class="placeholder">
            {{'PERSONAL_DATA_PAGE.FIRSTNAME' | translate}}
          </label>
          <ng-container *ngIf="form.get('firstnameFormControl')?.invalid && form.get('firstnameFormControl')?.touched">
            <span
              *ngIf="firstnameRequiredError"
              class="input-block__error">
              {{'PERSONAL_DATA_PAGE.FIRSTNAME_REQUIRED' | translate}}
            </span>
            <span
              *ngIf="firstnameFormatError"
              class="input-block__error">
              {{'PERSONAL_DATA_PAGE.FIRSTNAME_INVALID' | translate}}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="line">
        <div
          [class.error]="form.get('lastnameFormControl')?.invalid && form.get('lastnameFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="lastnameFormControl"
            id="lastname"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="lastname"
            class="placeholder">
            {{'PERSONAL_DATA_PAGE.LASTNAME' | translate}}
          </label>
          <ng-container *ngIf="form.get('lastnameFormControl')?.invalid && form.get('lastnameFormControl')?.touched">
            <span
              *ngIf="lastnameFormatError"
              class="input-block__error">
              {{'PERSONAL_DATA_PAGE.FIRSTNAME_INVALID' | translate}}
            </span>

            <span
            *ngIf="lastnameRequiredError"
            class="input-block__error">
            {{'PERSONAL_DATA_PAGE.LASTNAME_REQUIRED' | translate}}
          </span>
          </ng-container>
        </div>

        <div
          [class.error]="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="phoneFormControl"
            id="phone"
            prefix="+7 "
            mask="000 000 00 00"
            inputmode="numeric"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="phone"
            class="placeholder">
            {{'PERSONAL_DATA_PAGE.PHONE' | translate}}
          </label>
          <ng-container *ngIf="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched">
            <span
              *ngIf="phoneRequiredError"
              class="input-block__error">
              {{'PERSONAL_DATA_PAGE.PHONE_REQUIRED' | translate}}
            </span>
            <span
              *ngIf="phoneFormatError"
              class="input-block__error">
              {{'PERSONAL_DATA_PAGE.PHONE_INVALID' | translate}}
            </span>
          </ng-container>
        </div>
      </div>

      <button
        [disabled]="form.invalid"
        (click)="sendForm()"
        type="submit"
        class="btn btn-accent">
        {{'PERSONAL_DATA_PAGE.CONTINUE' | translate}}
      </button>
    </div>
  </form>

  <app-lang-select></app-lang-select>
</div>
